var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"slide-in-out",attrs:{"name":"slide"},on:{"enter":_vm.slideIn,"leave":_vm.slideOut,"after-enter":_vm.clearHeight}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }